import type { BlockUIDesignTokens } from '@primeuix/themes/types/blockui';

export default {
    root: {
        borderRadius: '{content.border.radius}',
    },
} satisfies BlockUIDesignTokens;
